var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPuzzles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EF52D1",
    d: "M7.335 7.25l3.067-1.886 1.381 3.74L8.508 11z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE863",
    d: "M2.743 6.141l1.044 3.447 2.329.625-1.074-3.388z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCA13D",
    d: "M.845 5.364L4.092 3.5l1.864.455-3 1.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCA13D",
    d: "M2.663 5.933l2.91-1.683 2.275.452-2.963 1.875zm5.335-1.231l3.501-1.952 1.864.455-2.961 2.16z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#45EFF3",
    d: "M11.03 2.901l2.566-1.651 2.606.375L13.496 3.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#9565FF",
    d: "M8.738 2.289L11.104.875l2.492.52-2.492 1.46z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#45EFF3",
    d: "M5.774 4.137l2.964-1.76 2.526.373-3.416 1.952z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#45EFF3",
    d: "M6.367 2.183L9.277.5l1.864.455-3 1.9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#45EFF3",
    d: "M3.404 3.683L6.314 2l1.864.455-3 1.9zm1.481 3l3.102-1.981 2.31.662-2.962 2.013z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3E572",
    d: "M4.885 6.5l1.124 3.838 2.33.625-1.155-3.924z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE863",
    d: "M.394 5.613l1.17 3.512 2.33.625-1.151-3.713z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCA13D",
    d: "M8.508 11.246L11.641 9.5l1.005 3.252-2.914 1.915z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#9565FF",
    d: "M9.778 14.667l3.033-2.167 1.141 3.679-2.98 1.946z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#EF52D1",
    d: "M4.885 13.25l2.293.75 1.037 3.375-2.301-.84z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#EF52D1",
    d: "M7.107 14l2.294.75 1.205 3.375-2.47-.84z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#EF52D1",
    d: "M4.052 9.847l2.272.74 1.104 3.64-2.294-.602z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#EF52D1",
    d: "M6.324 10.587l2.184.728 1.142 3.661-2.293-.601z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#9565FF",
    d: "M1.828 9.286l2.039.56 1.175 3.404-2.172-.75z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCA13D",
    d: "M2.663 12.5l2.293.75 1.037 3.375-2.071-.807z"
  })), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.18,
    fill: "#646464",
    style: {
      mixBlendMode: "color-burn"
    },
    d: "M.494 5.613l.89.26L5.043 16.25l-1.12-.432z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.18,
    fill: "#646464",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M.494 5.613l.89.26L5.043 16.25l-1.12-.432z"
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3E572",
    d: "M11.552 9.177L14.24 7.25l1.294 3.589-2.776 1.735z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#45EFF3",
    d: "M14.515 7.677l2.778-2.186 1.205 3.612-3.001 1.97z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#EF52D1",
    d: "M15.679 10.895l2.698-1.792 1.138 3.248-2.94 1.801z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3E572",
    d: "M13.033 12.177l2.688-1.927 1.294 3.589-2.775 1.735z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE863",
    d: "M13.496 3.506L14.67 7.25l-2.887 1.853-1.381-3.49z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#EF52D1",
    d: "M16.226 2l1.251 3.364-3.07 1.812-.911-3.162z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M15.328 2.593l3.26 10.492.927-.763L16.367 2zM8.034 1.036L9.45.5l6.967 1.129-1.161.664z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#2A2825"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.9,
    strokeLinejoin: "round",
    d: "M7.404 7.377l8.974-5.564 3.131 10.509-8.596 5.803z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.452 3.653l3.306 10.5m-6.181-8.415l3.464 10.324",
    strokeWidth: 0.63
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.836 5.613l6.491 1.764",
    strokeWidth: 0.85,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.913 18.283l-6.924-2.461L.45 5.582 9.099.5l7.29 1.125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.669 2L13.5 3.361m-9.801.399L10.3 5.343",
    strokeWidth: 0.63,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.77 1.25L4.893 6.577M11.19.875l-8.888 5.25",
    strokeWidth: 0.525
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.677 6.141l3.528 10.492M4.894 6.396L8.42 17.375",
    strokeWidth: 0.63
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.65 9.118l6.948 2.128M2.894 12.5l6.674 2.25",
    strokeWidth: 0.525
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.598 11.105l8.908-5.763",
    strokeWidth: 0.741
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.08 14.51l8.148-5.407",
    strokeWidth: 0.741,
    strokeLinecap: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzles);
export default __webpack_public_path__ + "static/media/puzzles.c9c4d07a331a0b1460a02682a71c085e.svg";
export { ForwardRef as ReactComponent };